.allResults {
  // &::after {
  //   content: "";
  //   display: block;
  //   width: 100%;
  //   height: 56px;
  //   position: absolute;
  //   background: linear-gradient(180deg, rgba(16, 16, 16, 0) 0%, rgba(16, 16, 16, 0.67) 49.57%);
  //   border-bottom-right-radius: 24px;
  //   border-bottom-left-radius: 24px;
  //   bottom: 1px;
  //   left: 0;
  // }

  .phone &,
  .tablet & {
    padding-top: 8px;
  }

  .categoryResults {
    margin-bottom: 40px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}